const convertToMonthsAndDays = (ms: number): { months: number; days: number } => {
  const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
  const AVERAGE_DAYS_IN_A_MONTH = 30.44; // Approximate days in a month

  const totalDays = (ms ?? 0) / MS_IN_A_DAY;
  const months = Math.floor(totalDays / AVERAGE_DAYS_IN_A_MONTH);
  const days = Math.round(totalDays % AVERAGE_DAYS_IN_A_MONTH);

  return { months, days };
};

const convertToMilliseconds = (months: number, days: number): number => {
  const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
  const AVERAGE_DAYS_IN_A_MONTH = 30.44;

  const daysFromMonths = months * AVERAGE_DAYS_IN_A_MONTH;
  const totalDays = daysFromMonths + days;

  return totalDays * MS_IN_A_DAY;
};

const generateNewDeadline = (dayMonth: number, oldDate: Date | null): Date | null => {
  if (dayMonth === 0) {
    if (oldDate) {
      return new Date(oldDate);
    } else {
      return null;
    }
  }
  const deadlineDate = new Date().getTime() + dayMonth;
  const newDeadline = new Date(deadlineDate);
  return newDeadline;
};

const isMoreThanTwoWeeks = (deadline: number, approvedDate: number): boolean => {
  return approvedDate > deadline;
};

const isExpire = (dateToCheck: Date | string, compareTo: Date | string): boolean => {
  if (!dateToCheck || !compareTo) return false;
  const a = new Date(dateToCheck);
  const b = new Date(compareTo);
  return a > b;
};

const isMoreThanOneYear = (deadline: number, currentTime: number): boolean => {
  const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
  const newDeadline = currentTime + new Date().getTime();
  return newDeadline - deadline > oneYearInMs;
};
const isDeadline = (newDeadline: Date | null, deadline: Date | null): boolean => {
  let deadLineMilliseconds: number | null = null;
  const currentTime = new Date().getTime();
  if (deadline) {
    deadLineMilliseconds = new Date(deadline).getTime();
  }
  if (newDeadline) {
    deadLineMilliseconds = new Date(newDeadline).getTime();
  }
  if (!deadLineMilliseconds) return false;
  return isMoreThanTwoWeeks(deadLineMilliseconds, currentTime);
};
export { isExpire, isDeadline, isMoreThanTwoWeeks, convertToMilliseconds, convertToMonthsAndDays, isMoreThanOneYear, generateNewDeadline };
